(() => {
    window.Dashboard = window.Dashboard || {};

    window.Dashboard.Models = window.Dashboard.Models || {};
    window.Dashboard.Models.Permissions = window.Dashboard.Models.Permissions || {};

    /**
     * The Role Context used to check if the user has permissions
     * @constructor
     */
    class RoleContext {
        BrandId = undefined;
        BrandName = undefined
        ProvinceId = undefined;
        StoreId = undefined;
        StoreName = undefined;
        CallCenterId = undefined;
        CallCenterName = undefined;
        GroupId = undefined;
        ContextType = undefined;
        RoleId = undefined;
        UserId = undefined;

        /**
         * Gets the current context of the user's name
         * @returns {string}
         */
        getCurrentContextName() {
            switch (this.ContextType) {
                case Dashboard.ContextTypes.BrandContext:
                    return this.BrandName;
                case Dashboard.ContextTypes.CallCenterContext:
                    return this.CallCenterName;
                case Dashboard.ContextTypes.StoreContext:
                    return this.StoreName;
                default:
                    return '';
            }
        }

        /**
         * Gets the current context type
         * @returns {string}
         */
        getCurrentContextType() {
            switch (this.ContextType) {
                case Dashboard.ContextTypes.BrandContext:
                    return Dashboard.DisplayContextTypes.Brand;
                case Dashboard.ContextTypes.CallCenterContext:
                    return Dashboard.DisplayContextTypes.CallCenter;
                case Dashboard.ContextTypes.StoreContext:
                    return Dashboard.DisplayContextTypes.Restaurant;
                default:
                    return '';
            }
        };

        /**
         * Navigates to a specific state passing in context values based on the current context
         * @param {string} newState
         * @param {$state} stateService
         */
        navigateToStateForCurrentContext(newState, stateService) {
            switch (this.ContextType) {
                case window.Dashboard.ContextTypes.BrandContext:
                    return stateService.go(newState, { brandId: this.BrandId });
                case window.Dashboard.ContextTypes.CallCenterContext:
                    return stateService.go(newState, { callCenterId: this.CallCenterId });
                case window.Dashboard.ContextTypes.StoreContext:
                    return stateService.go(newState, { storeId: this.StoreId });
                default:
                    throw new Error(`unknown context type '${this.ContextType}' - cannot navigate away from page`);
            }
        }

        /**
         * Returns true if the current role context is a Brand context
         * @returns {boolean}
         */
        isBrandContext() {
            return this.ContextType === Dashboard.ContextTypes.BrandContext;
        }

        /**
         * Returns true if the current role context is a Call Center context
         * @returns {boolean}
         */
        isCallCenterContext() {
            return this.ContextType === Dashboard.ContextTypes.CallCenterContext;
        };

        /**
         * Returns true if the current role context is a Store context
         * @returns {boolean}
         */
        isStoreContext() {
            return this.ContextType === Dashboard.ContextTypes.StoreContext;
        };
    }

    window.Dashboard.Models.Permissions.RoleContext = RoleContext;
})();
